import React from "react";
import { Container } from "react-bootstrap";
import LumenNavbar from "./LumenNavbar";
import NewFooter from "./NewFooter";
import "./LegalPageLayout.css";

interface LegalPageLayoutProps {
  title: string;
  children: React.ReactNode;
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({
  title,
  children,
}) => {
  return (
    <div className="legal-page">
      <LumenNavbar />
      <main className="legal-page-body">
        <Container>
          <h1>{title}</h1>
          <hr className="legal-divider" />
          {children}
        </Container>
      </main>
      <NewFooter />
    </div>
  );
};

export default LegalPageLayout;
